/**
 * 把落地页画成二维码。生成算法来自同目录的 qrcodegen.ts（Nayuki，MIT）。
 */
import { qrcodegen } from './qrcodegen.ts'

export function drawQr(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  size: number,
): void {
  const qr = qrcodegen.QrCode.encodeText(text, qrcodegen.QrCode.Ecc.MEDIUM)
  const modules = qr.size
  const quiet = 4
  const span = modules + quiet * 2
  const cell = size / span
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(x, y, size, size)
  ctx.fillStyle = '#1c1917'
  for (let row = 0; row < modules; row++) {
    for (let col = 0; col < modules; col++) {
      if (!qr.getModule(col, row)) continue
      ctx.fillRect(x + (col + quiet) * cell, y + (row + quiet) * cell, Math.ceil(cell), Math.ceil(cell))
    }
  }
}
